/* eslint-disable */
export default {
  matched: 'Entsprechung gefunden',
  other: 'Sonstiges',
  associated: 'Zugeordnet',
  foundFromServer: 'Gefunden aus {appName}',
  recently: 'Aktuell',
  additionalLabelAccount: 'Konto: {displayName}',
  additionalLabelContact: 'Kontakt: {displayName}',
  notFound: 'K. A.',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
